import React, { useState } from "react";
import "./setPassword.css";
import NarrowPasswordField from "../../components/input/new/narrowPasswordField";
import SetPasswordImg from "./assets/setPassword.png";
import SignupToolbar from "../../components/lawyerToolbar/signupToolbar";
import DeterminateProgress from "../../components/input/new/determinateProgress";
import { supabase } from "../../supabaseClient"; // Import your Supabase client
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { authenticatedFetch } from "../../network/api";

export default function SetPassword() {
  const [password, setPassword] = useState("");
  const [agreed, setAgreed] = useState(false);
  const attorney = useSelector((state) => state.attorney); // Get all lawyer info from Redux
  const navigate = useNavigate();

  const email = attorney.email;
  const handleCheckboxChange = () => {
    setAgreed((prev) => !prev);
  };

  // const handleContinue = async (email, password, role) => {
  //   try {
  //     // Use Supabase's auth.signUp to send the email and password
  //     const { user, error } = await supabase.auth.signUp({
  //       email,
  //       password,
  //       options: {
  //         emailRedirectTo: "https://www.quidpro.ai/complete-signup/",
  //         data: {
  //           role: role,
  //         },
  //       },
  //     });

  //     if (error) {
  //       console.error("Error signing up:", error.message);
  //       alert("Failed to send verification email.");
  //       return;
  //     }

  //     // Check if user object exists and has an id
  //     if (!user || !user.id) {
  //       console.error("User object is missing or invalid:", user);
  //       alert("Failed to create user account. Please try again.");
  //       return;
  //     }

  //     const response = await fetch("/api/attorney/webapp/createMainAccount", {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify({
  //         userId: user.id,
  //         lawyerInfo: attorney,
  //       }),
  //     });

  //     const result = await response.json();
  //     if (!result.success) {
  //       console.error("Error creating lawyer profile:", result.message);
  //       alert("Failed to create lawyer profile.");
  //       return;
  //     }

  //     navigate("/grow/confirm-email");
  //     // alert('Verification email sent! Please check your inbox.');
  //   } catch (error) {
  //     console.error("Unexpected error:", error);
  //     alert("Something went wrong. Please try again later.");
  //   }
  // };

  const handleContinue = async (email, password, role) => {
    try {
      // 1) Try sign up
      const { data, error } = await supabase.auth.signUp({
        email,
        password,
        options: {
          emailRedirectTo: `${window.location.origin}/complete-signup/`,
          data: { role },
        },
      });
  
      // 2) If email already exists, resend confirmation and proceed to confirm page
      if (error && /already|registered/i.test(error.message)) {
        await supabase.auth.resend({ type: "signup", email });
        navigate("/grow/confirm-email");
        return;
      }
  
      // 3) Any other real error: show the actual reason (don’t say “failed to send”)
      if (error) {
        console.error("Supabase signUp error:", error);
        alert(error.message || "Could not create account. Please try again.");
        return;
      }
  
      const userId = data?.user?.id;
      if (!userId) {
        // Very unlikely if signUp succeeded, but guard anyway
        console.error("No user returned from signUp:", data);
        alert("Account created, but we couldn't finish setup. Please retry.");
        return;
      }
  
      // 4) Create (or upsert) the main account — make your API idempotent
      const response = await fetch("/api/attorney/webapp/createMainAccount", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          userId,
          lawyerInfo: attorney,
        }),
      });
  
      const result = await response.json();
      if (!result?.success) {
        console.error("createMainAccount error:", result?.message);
        // Don’t block the flow to confirm email; log and still navigate
      }
  
      // 5) Always send them to the “check your email” screen
      navigate("/grow/confirm-email");
    } catch (err) {
      console.error("Unexpected error:", err);
      alert("Something went wrong. Please try again.");
    }
  };

  return (
    <div>
      <SignupToolbar onlyHelp={true} />
      <div className="create-password-container">
        {/* Main content area */}
        <div className="main-content">
          <div className="card-password">
            <div className="icon-wrapper">
              <img
                src={SetPasswordImg}
                alt="Set Password Icon"
                className="set-password-img"
              />

              {/* Heading */}
              <h2 className="password-title">Create your password</h2>
            </div>

            {/* Replace inline password field with the NarrowPasswordField component */}
            <NarrowPasswordField
              title="Password"
              placeholder="Enter your password"
              isRequired={true}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />

            {/* Password Requirements */}
            <ul className="password-requirements">
              <li>Use at least 8 characters</li>
              <li>Use letters</li>
              <li>Use numbers</li>
              <li>Use special characters, like !#$%?</li>
            </ul>

            {/* Terms & Conditions */}
            <div className="terms-container">
              <input
                type="checkbox"
                id="terms"
                checked={agreed}
                onChange={handleCheckboxChange}
              />
              <label htmlFor="terms" className="terms-label">
                I have read and accept the terms of the QuidPro&nbsp;
                <a href="/user-agreement" target="_blank" rel="noreferrer">
                  User Agreement
                </a>
                &nbsp;and&nbsp;
                <a href="/privacy-policy" target="_blank" rel="noreferrer">
                  Privacy Policy
                </a>
              </label>
            </div>
          </div>
        </div>

        {/* Bottom navigation bar */}
        <DeterminateProgress value={20} />
        <div className="bottom-bar">
          <div className="bottom-bar-left">
            <span className="section-label">Account</span>
            <span className="step-indicator">Step 1 of 5</span>
          </div>
          <button
            type="button"
            className="continue-btn-password"
            onClick={() => {
              handleContinue(email, password, "attorney");
            }}
            disabled={!agreed || password.length < 8}
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  );
}
